import { useQuery } from '@tanstack/react-query';

import { PricingPlanCap } from 'src/features/pricingPlan/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/pricing/pricing-plan/:planId/pricing-plan-cap/:capId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    planId: string;
    capId: string;
    parkingId: string;
}
const queryFn = ({ planId, capId, parkingId }: DTO): Promise<PricingPlanCap> => {
    return axios.get(formatResourcePath(RESOURCE, { planId, capId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetPricingPlanCap };
